var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTickCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3 4.7C24.4 1.8 20.4 0 16 0 7.2 0 0 7.2 0 16c0 4.4 1.8 8.4 4.7 11.3C7.6 30.2 11.6 32 16 32c8.8 0 16-7.2 16-16 0-4.4-1.8-8.4-4.7-11.3zM16 29.9C8.4 29.9 2.1 23.6 2.1 16S8.4 2.1 16 2.1 29.9 8.4 29.9 16 23.6 29.9 16 29.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6 19.4l-4.9-5L7.2 16l6.4 6.4 11.2-11.2-1.5-1.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickCircle);
export default __webpack_public_path__ + "static/media/TickCircle.074be617.svg";
export { ForwardRef as ReactComponent };